import { render, staticRenderFns } from "./changelog-page.vue?vue&type=template&id=d4005cd2&lang=pug&"
import script from "./changelog-page.vue?vue&type=script&lang=js&"
export * from "./changelog-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports